import {
  Text,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Checkbox,
  CheckboxGroup,
  Flex,
} from "@chakra-ui/react";
import PropTypes from "prop-types";

const RoleAccessController = ({
  data,
  step,
  totalSteps,
  onChange,
  isDisabled,
  allowedAccessByType,
}) => {
  const state = data;

  const getAllowedAccess = (subHeading) =>
    allowedAccessByType?.[subHeading] || ["GET", "POST", "PATCH", "DELETE"];

  const onAccessChange = (value, index, allowedAccess) => {
    const newState = { ...data, types: [...(data?.types || [])] };
    newState.types[index] = { ...newState.types[index] };
    newState.types[index].access = value.filter((v) =>
      allowedAccess.includes(v),
    );
    if (typeof onChange === "function") {
      onChange(newState);
    }
  };

  const onProvideAllAccess = (value, index, allowedAccess) => {
    const newState = { ...data, types: [...(data?.types || [])] };
    newState.types[index] = { ...newState.types[index] };

    if (value) {
      newState.types[index].access = [...allowedAccess];
    } else {
      newState.types[index].access = [];
    }
    if (typeof onChange === "function") {
      onChange(newState);
    }
  };

  return (
    <TableContainer
      bg={"white"}
      borderRadius={"2xl"}
      p={6}
      mt={2}
      border="1px solid #D0D5DD"
    >
      <Flex
        justifyContent={"space-between"}
        fontSize={"0.875rem"}
        letterSpacing={0}
        px={3}
      >
        <Text fontSize={22} fontWeight={500} my={2}>
          {" "}
          {state.heading}{" "}
        </Text>
        <Text color={"#90A3BF"} fontSize="md">
          Step {step} of {totalSteps}
        </Text>
      </Flex>
      <Table variant="simple" fontSize={15}>
        <Thead>
          <Tr textAlign="center">
            <Th w={"50%"}>Permission</Th>
            <Th textAlign="center"> Full Access </Th>
            <Th textAlign="center"> Create </Th>
            <Th textAlign="center"> View </Th>
            <Th textAlign="center"> Edit </Th>
            <Th textAlign="center"> Delete </Th>
          </Tr>
        </Thead>
        <Tbody>
          {state?.types?.map(({ subHeading, access = [] }, index) => {
            const allowedAccess = getAllowedAccess(subHeading);
            const rowDisabled = isDisabled || allowedAccess.length === 0;
            const isFullAccess =
              allowedAccess.length > 0 &&
              access.length === allowedAccess.length;

            return (
              <Tr key={subHeading + index} textAlign="center">
                <Td> {subHeading} </Td>
                <Td textAlign="center">
                  <Checkbox
                    isChecked={isFullAccess}
                    onChange={(e) => {
                      onProvideAllAccess(
                        e.target.checked,
                        index,
                        allowedAccess,
                      );
                    }}
                    borderColor={"gray.500"}
                    isDisabled={rowDisabled}
                  />
                </Td>
                <CheckboxGroup
                  value={access}
                  onChange={(value) =>
                    onAccessChange(value, index, allowedAccess)
                  }
                >
                  <Td textAlign="center">
                    {" "}
                    <Checkbox
                      value={"POST"}
                      borderColor={"gray.500"}
                      isDisabled={
                        rowDisabled || !allowedAccess.includes("POST")
                      }
                    />{" "}
                  </Td>
                  <Td textAlign="center">
                    {" "}
                    <Checkbox
                      value={"GET"}
                      borderColor={"gray.500"}
                      isDisabled={rowDisabled || !allowedAccess.includes("GET")}
                    />{" "}
                  </Td>
                  <Td textAlign="center">
                    {" "}
                    <Checkbox
                      value={"PATCH"}
                      borderColor={"gray.500"}
                      isDisabled={
                        rowDisabled || !allowedAccess.includes("PATCH")
                      }
                    />{" "}
                  </Td>
                  <Td textAlign="center">
                    {" "}
                    <Checkbox
                      value={"DELETE"}
                      borderColor={"gray.500"}
                      isDisabled={
                        rowDisabled || !allowedAccess.includes("DELETE")
                      }
                    />{" "}
                  </Td>
                </CheckboxGroup>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </TableContainer>
  );
};

RoleAccessController.propTypes = {
  step: PropTypes.number,
  totalSteps: PropTypes.number,
  data: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool,
  allowedAccessByType: PropTypes.object,
};

export { RoleAccessController };
